import { type SingleSelectedValueFilter } from '../types'
import CoverageStartDateFilter from './CoverageStartDateFilter'

const CoverageStartAfterDateFilter = (props: SingleSelectedValueFilter) => {
  return (
    <CoverageStartDateFilter {...props} rangeType='Coverage starts after' />
  )
}

export default CoverageStartAfterDateFilter
